import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { TableContainer } from 'components/DefaultTable/styles';

export const FilterWrapper = styled.div`
  margin: 40px 0 24px;
`;

export const Table = styled(TableContainer)`
  tbody tr {
    &:hover {
      background-color: transparent;
      cursor: default;
    }

    td {
      &:last-child:hover {
        cursor: pointer;
      }

      svg {
        height: 24px;
        transition: all 0.3s ease-in-out;
        width: 24px;

        &:hover {
          opacity: 0.3;
        }
      }
    }
  }
`;

export const ViewAppointments = styled(Link)``;
